export const ADMIN_DOMAIN = 'admin';
export const ADMIN_DOMAIN_URL = `/${ADMIN_DOMAIN}/*`;

export const ADMIN_DOMAIN_PATHS = {
  billing: '/billing',
  users: '/users',
  updateUser: 'update',
  templates: '/templates/:tab',
  rfiTemplates: '/rfi/templates',
  rfiTemplateDetail: ':uuid',
  rfiTemplateEdit: 'edit',
};

export const ADMIN_DOMAIN_PAGE_TITLES = {
  billing: 'Billing | Admin',
  users: 'Users | Admin',
  updateUser: 'Update | Users | Admin',
  templates: 'Templates | Admin',
  rfiTemplateDetail: 'Template Details | Admin',
  rfiTemplateEdit: 'Customize Template | Admin',
};
